import React, { Component } from "react";
import Immutable from "immutable";
import { withStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import Box from "@material-ui/core/Box";
import clsx from "clsx";
import Typography from "@material-ui/core/Typography";
import { withRouter } from "react-router-dom";
import getRemainingTime from "helpers/getRemainingTime";
import gotoLiveRoom from "helpers/gotoLiveRoom";
import i18n from "helpers/i18n";

const styles = (theme) => {
  return {
    // wrapper: {
    //   margin: "0 auto 100px",
    //   [theme.breakpoints.up("md")]: {
    //     padding: "0 20px",
    //   },
    //   [theme.breakpoints.up("lg")]: {
    //     padding: "0 100px",
    //   },
    // },
    root: {
      '& .MuiTypography-h4': {
        // color: '#fff'
        marginBottom: 0,
        '& a': {
          color: theme.palette.primary.main
        }
      }
    },
    homeTitles: {
      [theme.breakpoints.down("sm")]: {
        textAlign: "center",
      },
    },
    // inline: {
    //   display: "inline-block",
    // },
    // emphasis: {
    //   color: theme.palette.secondary.main,
    // },
    oversizeButton: {
      fontSize: "1rem",
      padding: 20,
      fontWeight: "bold",
      color: theme.palette.primary.main,
      backgroundColor: "rgba(255, 255, 255, 0.8)",
      [theme.breakpoints.down("sm")]: {},
      [theme.breakpoints.up("lg")]: {
        padding: "20px 50px",
        fontSize: "1.2rem",
      },
    },
    homeTitles: {
      [theme.breakpoints.down("sm")]: {
        textAlign: "center",
        margin: "20px auto",
      },
    },
    homeButtons: {
      [theme.breakpoints.down("sm")]: {
        margin: theme.spacing(3) + "px",
      },
      "& .MuiGrid-item:first-child": {
        marginBottom: theme.spacing(4),
        [theme.breakpoints.down("sm")]: {
          marginBottom: theme.spacing(3),
        },
      },
    },
    top: {
      padding: "0 20px",
      height: "calc(100% - 200px)",
      [theme.breakpoints.down("sm")]: {
        height: "auto",
      },
    },
    bottom: {
      height: 200,
      backgroundColor: "rgba(255, 255, 255, 0.8)",
      padding: "20px 30px",
      [theme.breakpoints.down("sm")]: {
        height: "auto",
      },
    },
  };
};
class HomeNoEvents extends Component {
  // constructor(props) {
  //   super(props);
  //   this.state = {
  //     showLiveButton: false,
  //   };
  //   // this._runRemainingTimer = this._runRemainingTimer.bind(this);
  //   // this._gotoLiveRoom = this._gotoLiveRoom.bind(this);
  // }
  // componentDidMount() {
  //   // console.log('START')
  //   // this._startTimer();
  // }
  // componentDidUpdate(oldProps) {
  //   // console.log(oldProps.$$data.toJS(), oldProps.userRole, this.props.userRole)
  //   if (
  //     (oldProps.userRole === undefined && this.props.userRole !== undefined) ||
  //     (this.props.userRole !== undefined &&
  //       oldProps.$$data !== this.props.$$data)
  //   ) {
  //     // console.log('GOGOGO')
  //     this._startTimer();
  //   }
  // }
  // _stopTimer() {
  //   // console.log('timer stop')
  //   if (this._remainingTimer) {
  //     clearInterval(this._remainingTimer);
  //   }
  // }
  // _startTimer() {
  //   // console.log('timer start')
  //   // const $$card = this._getCard();
  //   // console.log('test1')
  //   if (this._remainingTimer) return;
  //   const $$liveEvent = this._getMyLiveEvent();
  //   // console.log('test2', $e)
  //   if ($$liveEvent === undefined) return;
  //   // console.log('starting timer')
  //   // this._cardTimer = $$card.get('eventDate');
  //   this._remainingTimer = setInterval(this._runRemainingTimer, 1000);
  //   this._runRemainingTimer();
  // }
  // _runRemainingTimer() {
  //   // console.log('run1')
  //   const $$liveEvent = this._getMyLiveEvent();
  //   // console.log('run2', $e)
  //   if ($$liveEvent === undefined) {
  //     return this._stopTimer();
  //   }
  //   // console.log('run3')
  //   // console.log($e)
  //   // console.log($e.get('eventState'))
  //   const timeRemaining =
  //     $$liveEvent !== undefined && $$liveEvent.get("eventState") != "live"
  //       ? getRemainingTime($$liveEvent.get("eventDate"))
  //       : { days: 0, hours: 0, minutes: 0 };
  //   // console.log(timeRemaining)
  //   if (
  //     timeRemaining.days <= 0 &&
  //     timeRemaining.hours <= 0 &&
  //     timeRemaining.minutes <= 15
  //   ) {
  //     this.setState({ showLiveButton: true }, () => {
  //       // console.log('STOPPPING')
  //       this._stopTimer();
  //     });
  //   } else {
  //     // console.log('RUN')
  //     this.setState({ timeRemaining });
  //   }
  // }

  _goto = (url) => {
    const { history } = this.props;
    history.push(url);
  };
  // _gotoLiveRoom = (e) => {
  //   const { $$user } = this.props;
  //   e.preventDefault();
  //   const $$liveEvent = this._getMyLiveEvent();
  //   gotoLiveRoom($$liveEvent, (res) => {
  //     if (res === true) this._goto("/live/" + $$liveEvent.get("id"));
  //   });
  // };
  // _getMyLiveEvent() {
  //   const { $$data } = this.props;
  //   if ($$data !== undefined) {
  //     // console.log($$subscriptions)
  //     // console.log($$data.get('myfutureevents'))
  //   }
  //   const $$subscriptions = this._getMySubscriptions();
  //   return $$subscriptions !== undefined &&
  //     $$subscriptions.size > 0 &&
  //     $$subscriptions.get(0) !== undefined
  //     ? $$data.get("myfutureevents").get(0)
  //     : undefined;
  // }
  // _getMyPastEvent() {
  //   const { $$data } = this.props;
  //   if ($$data !== undefined) {
  //     // console.log($$data.toJS())
  //     // console.log($$subscriptions)
  //     // console.log($$data.get('myfutureevents'))
  //     // console.log($$data.get('mypastevents').filter($e => $e.get('hasAttended') !== undefined && $e.get('hasAttended') !== '' && $e.get('hasAttended') !== null).toJS())
  //   }
  //   return $$data !== undefined &&
  //     $$data.get("mypastevents") !== undefined &&
  //     $$data.get("mypastevents").size > 0
  //     ? $$data
  //         .get("mypastevents")
  //         .filter(
  //           ($e) =>
  //             $e.get("hasAttended") !== undefined &&
  //             $e.get("hasAttended") !== "" &&
  //             $e.get("hasAttended") !== null
  //         )
  //         .get(0)
  //     : undefined;
  // }
  // _getMySubscriptions() {
  //   const { userRole, $$data } = this.props;
  //   const $$subscriptions =
  //     userRole !== undefined &&
  //     $$data !== undefined &&
  //     $$data.get("myfutureevents") !== undefined
  //       ? $$data.get("myfutureevents").map((e) => e.get("id"))
  //       : Immutable.Map();
  //   return $$subscriptions;
  // }
  render() {
    const {
      $$data,
      userRole,
      $$user,
      onSubscriptionComplete,
      classes,
      isLoggedIn,
    } = this.props;

    return (
      <React.Fragment>
        <Grid
          item
          xs={12}
          container
          justify="center"
          alignItems="center"
          className={clsx(classes.top, classes.root)}
          >
          <Grid item xs={12} md={8} className={classes.homeTitles}>
            <Typography variant={"h1"}>{i18n.get("homeTitle")}</Typography>
            <Typography variant={"h2"}>{i18n.get("homeSubtitle1")}</Typography>
            <Typography variant={"h2"}>{i18n.get("homeSubtitle2")}</Typography>
            <If condition={i18n.has("homeSubtitle3")}>
              <Typography variant={"h2"}>
                {i18n.get("homeSubtitle3")}
              </Typography>
            </If>
          </Grid>
          <Grid
            item
            xs={12}
            md={4}
            container
            justify="flex-start"
            className={classes.homeButtons}
            >
            <If condition={!isLoggedIn}>
              <Grid item xs={12}>
                <Button
                  variant="contained"
                  fullWidth
                  className={classes.oversizeButton}
                  onClick={(e) => {
                    e.preventDefault();
                    this._goto("/registration");
                  }}
                  >
                  {i18n.get("homeRegisterBtn")}
                </Button>
              </Grid>
              <Grid item xs={12}>
                <Button
                  variant="contained"
                  fullWidth
                  className={classes.oversizeButton}
                  onClick={(e) => {
                    e.preventDefault();
                    this._goto("/login");
                  }}
                  >
                  {i18n.get("homeLoginBtn")}
                </Button>
              </Grid>
            </If>
{/*            <If condition={isLoggedIn}>
              <Grid item xs={12}>
                <Paper>
                  <Box ml={2} p={3} align="center">
                    <If condition={$$data === undefined || $$data.get('replays') === undefined || $$data.get('replays').size === 0}>

                    <Typography variant="h4" color="secondary">{i18n.get('homeNoAvailableEvent', {pretty: true})}</Typography>
                    </If>
                    <If condition={$$data !== undefined && $$data.get('replays') !== undefined && $$data.get('replays').size > 0}>
                      <Typography variant="h4" color="secondary">{i18n.get('homePlayReplaysInstead', {pretty: true})}</Typography>
                    </If>
                  </Box>
                </Paper>
              </Grid>

            </If>
*/}
          </Grid>
        </Grid>

        <Grid
          item
          xs={12}
          container
          spacing={0}
          alignItems="flex-start"
          justify="space-around"
          className={classes.bottom}
          >
          <Grid item xs={12}>
            <Typography variant={"h4"} align="center">
              {i18n.get("homeBannerTitle")}
            </Typography>
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <Typography variant="body1" align="center" gutterBottom>
              {i18n.get("homeBannerText1")}
            </Typography>
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <Typography variant="body1" align="center" gutterBottom>
              {i18n.get("homeBannerText2")}
            </Typography>
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <Typography variant="body1" align="center" gutterBottom>
              {i18n.get("homeBannerText3")}
            </Typography>
          </Grid>
        </Grid>
      </React.Fragment>
    );
  }
}

export default withRouter(withStyles(styles)(HomeNoEvents));



// WEBPACK FOOTER //
// ./src/components/Home/HomeNoEvents.jsx